module.exports = __webpack_public_path__ + "img/2.0c3392f7.png";